const hasCalendarVisibility = (calendarTargets, calendarId) => (
    Boolean(calendarTargets)
    && Object.prototype.hasOwnProperty.call(calendarTargets, calendarId)
);

export const isCalendarAutomatic = (calendarTargets, calendarId) => (
    !hasCalendarVisibility(calendarTargets, calendarId)
);

export const isCalendarPublic = (calendarTargets, calendarId) => (
    hasCalendarVisibility(calendarTargets, calendarId)
    && Array.isArray(calendarTargets[calendarId])
    && calendarTargets[calendarId].length === 0
);

export const setCalendarAutomatic = (calendarTargets, calendarId) => {
    const updatedTargets = { ...(calendarTargets || {}) };
    delete updatedTargets[calendarId];
    return updatedTargets;
};

export const setCalendarPublic = (calendarTargets, calendarId) => ({
    ...(calendarTargets || {}),
    [calendarId]: [],
});

export const setCalendarTarget = (calendarTargets, calendarId, target, checked) => {
    const currentTargets = Array.isArray(calendarTargets?.[calendarId])
        ? calendarTargets[calendarId]
        : [];
    const updatedTargets = checked
        ? [...new Set([...currentTargets, target])]
        : currentTargets.filter(currentTarget => currentTarget !== target);

    return {
        ...(calendarTargets || {}),
        [calendarId]: updatedTargets,
    };
};

export const getCalendarUpdateErrorMessage = error => {
    const invalidCalendarIds = (error?.invalid_calendars || [])
        .map(({ calendarId }) => calendarId)
        .filter(Boolean);

    if (invalidCalendarIds.length > 0) {
        return `No s'ha pogut accedir a ${invalidCalendarIds.join(', ')}. `
            + `Comprova l'ID i comparteix-lo amb l'Aleta.`;
    }

    return 'No s’han pogut desar els calendaris. Torna-ho a provar.';
};
